import React, { Component } from "react";
import { Modal, Input, Form, Label, Button, TextArea } from "semantic-ui-react";
import moment from "moment";
class AbsenceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateout: null,
      datereturn: null,
      comments: ""
    };
  }
  render() {
    var newabsence = {
      dateout: this.state.dateout,
      datereturn: this.state.datereturn,
      comments: this.state.comments
    };
    return (
      <Modal
        size="large"
        open={this.props.showModal}
        onClose={() => {
          if (this.state.absence) {
            delete this.state.absence;
            this.setState({
              dateout: null,
              datereturn: null,
              comments: ""
            });
          }
          this.props.handleclose();
        }}
      >
        <Modal.Header>Request Absence</Modal.Header>

        <Modal.Content>
          <Form>
            <Form.Group>
              <Form.Field>
                <Label>Select date out to request absence.</Label>
                <Input
                  placeholder="MM/DD/YYYY"
                  type="date"
                  value={this.state.dateout}
                  onChange={e =>
                    this.setState({
                      dateout: moment(e.target.value).format("YYYY-MM-DD")
                    })
                  }
                />
              </Form.Field>
              <Form.Field>
                <Label>Select date return to request absence.</Label>
                <Input
                  placeholder="MM/DD/YYYY"
                  type="date"
                  value={this.state.datereturn}
                  onChange={e =>
                    this.setState({
                      datereturn: moment(e.target.value).format("YYYY-MM-DD")
                    })
                  }
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field fluid>
                <Form.Field
                  control={TextArea}
                  value={this.state.comments}
                  label="Comments"
                  onChange={e => this.setState({ comments: e.target.value })}
                  placeholder="Enter Comments"
                />
              </Form.Field>
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            negative
            icon="cancel"
            labelPosition="right"
            disabled={!this.state.absence}
            content="Delete"
            onClick={() => {
              this.props.deleteabsence(this.state.absence.id);
            }}
          />
          <Button
            positive
            icon="checkmark"
            labelPosition="right"
            disabled={!this.state.dateout || !this.state.datereturn}
            content={this.state.absence ? "Update" : "Request Absence"}
            onClick={() => {
              if (this.state.absence) {
                this.props.updateabsence({
                  ...this.state.absence,
                  dateout: this.state.dateout,
                  datereturn: this.state.datereturn,
                  comments: this.state.comments
                });
                delete this.state.absence;
                this.props.handleclose();
              } else {
                this.props
                  .addabsence(newabsence)
                  .then(() => this.props.handleclose());
              }
            }}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}
export default AbsenceModal;



// WEBPACK FOOTER //
// ./src/components/home-components/absencemodal.js